import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const ClosingCta: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col items-center gap-5 pb-16 text-center md:pb-32">
			<Text as="h2" variant="heading" size="x-large" fontWeight="bold">
				<Translate value="corgi.impact_page.cta.heading" />
			</Text>
			<Text as="p" variant="body" size="large" className="text-typography-weak mx-auto max-w-xl">
				<Translate value="corgi.impact_page.cta.body" />
			</Text>
			<div className="mt-3 flex w-full flex-col justify-center gap-3 md:w-auto md:flex-row">
				<Button
					as="a"
					href="/start-a-petition/intro"
					variant="primary"
					size="large"
					className="w-full md:w-auto"
					data-qa="impact-cta-start-petition"
				>
					<Translate value="corgi.impact_page.cta.start_petition" />
				</Button>
				<Button
					as="a"
					href="/search"
					variant="secondary"
					size="large"
					className="w-full md:w-auto"
					data-qa="impact-cta-sign-petition"
				>
					<Translate value="corgi.impact_page.cta.sign_petition" />
				</Button>
				<Button
					as="a"
					href="/member/join"
					variant="tertiary"
					size="large"
					className="w-full md:w-auto"
					data-qa="impact-cta-become-member"
				>
					<Translate value="corgi.impact_page.cta.become_member" />
				</Button>
			</div>
		</section>
	);
};
